var _rect, _rect2, _polygon, _path, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -22.44,
    y: 20.1,
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -22.44,
    y: 20.1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "30.11 13.01 10.5 32.62 7.77 39.81 15.28 37.64 35.53 18.43 30.11 13.01",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.93,7.2l-2.99,2.99,5.5,5.5,3.05-2.89c-.14-.56-.61-1.57-1.72-2.82-1.5-1.68-3.09-2.59-3.84-2.78Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,6.16c-1.24-1.15-4.41-3.71-7.2-2.81-.3,.1-.57,.27-.8,.49L7.37,30.1c-.2,.2-.36,.44-.46,.7l-4.31,11.33c-.27,.71-.12,1.51,.4,2.06,.38,.42,.92,.65,1.47,.65,.19,0,.37-.03,.55-.08l11.83-3.41c.31-.09,.59-.25,.82-.47L44.84,15.12c.28-.27,.48-.61,.57-.98,.65-2.7-1.53-5.89-3.78-7.98ZM15.28,37.64l-7.51,2.16,2.73-7.18L30.11,13.01l5.42,5.42L15.28,37.64ZM38.44,15.68l-5.5-5.5,2.99-2.99c.75,.19,2.34,1.1,3.84,2.78,1.12,1.25,1.59,2.26,1.72,2.82l-3.05,2.89Z",
    fill: outlineColor
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.3b6762f897cfdb7efeddbb8dbc561aa3.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;